let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5yF0J")).then(() => parcelRequire('c8PQm'));